import { MessageCircle } from "lucide-react";
import { useExplorer } from "@/context/ExplorerContext";
import { waLink } from "@/config";

export const FloatingWhatsApp = () => {
  const { t } = useExplorer();
  return (
    <a
      href={waLink(t.order.waMessage)}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label={t.footer.whatsappLabel}
      className="fixed bottom-24 end-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-cream shadow-[0_12px_28px_-10px_rgba(37,211,102,0.8)] transition-transform duration-300 hover:-translate-y-0.5 md:bottom-6 md:end-6"
    >
      <MessageCircle size={26} strokeWidth={2} />
    </a>
  );
};
